var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "358px",
    height: "200px",
    viewBox: "0 0 358 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L352,0 C355.313708,-6.08718376e-16 358,2.6862915 358,6 L358,200 L358,200 L0,200 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "28.701658%",
    x2: "100%",
    y2: "138.491308%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E1939",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E35785",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "28.701658%",
    x2: "100%",
    y2: "96.6036063%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C2248",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E35785",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.8325986%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.7711522%",
    y1: "-28.1859254%",
    x2: "62.9188522%",
    y2: "121.546626%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07777",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.7132608%",
    y1: "-1.01553957%",
    x2: "55.1442779%",
    y2: "86.9598487%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "24.9383281%",
    x2: "50%",
    y2: "63.1582978%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.2332932%",
    y1: "35.9536706%",
    x2: "59.3427958%",
    y2: "59.8897166%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1ADAD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA947B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.5993705%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "111.153913%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47070",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.4928488%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "111.153913%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47070",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Knowledge-Base",
    transform: "translate(-288.000000, -445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(288.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wom2.4",
    transform: "translate(141.000000, 109.000000) scale(-1, 1) translate(-141.000000, -109.000000) translate(95.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(27.061852, 78.228685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.88594311e-15,4.37589234e-14 C-6.88594311e-15,4.37589234e-14 6.48105157,59.2260826 7.00989811,64.6376349 C7.53874465,70.0491873 6.48105157,73.9676018 6.04734946,79.5570489 C5.61364735,85.1464961 7.70114635,120.300164 7.70114635,120.300164 C10.7701219,122.059781 14.422078,122.405115 19.0651007,120.353353 C19.0651007,120.353353 23.3291862,76.5602068 23.2875448,66.585604 C23.2625599,60.6355345 23.9121667,0.668043157 23.9121667,0.668043157 L-6.88594311e-15,4.37589234e-14 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    transform: "translate(19.727229, 67.045022) rotate(3.000000) translate(-19.727229, -67.045022) ",
    cx: 19.727229,
    cy: 67.0450224,
    rx: 2.58397971,
    ry: 4.00358082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3558939,65.12386 C10.8882244,68.8703502 9.45822127,75.967155 6.06588444,86.4142744 L6.02315112,84.6965348 C5.97468415,82.4252694 5.97320337,80.6540786 6.03911524,79.6711929 L6.04734946,79.5570489 C6.46659484,74.1539167 7.4689251,70.3122716 7.05757617,65.1739302 L6.96859287,64.2243076 C6.74636709,62.0343948 6.05567616,55.6101325 5.19024831,47.6220374 L5.66512445,48.9273535 C8.29344929,56.2131484 9.85690282,61.6120089 10.3558939,65.12386 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(6.460736, 75.749808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4595307,0 C16.4595307,0 9.38862241,5.96590767 7.53223266,14.5369843 C4.43764126,28.8249213 5.99503186,55.2137988 5.90342065,61.0003307 C5.81597359,66.7868625 3.59344626,70.2782735 2.40137388,78.4599541 C1.20930149,86.6416348 2.38888144,123.206733 2.38888144,123.206733 C5.54946824,124.992151 8.97656039,125.119964 12.7451125,123.09956 L34.8775484,1.90847994 L16.4595307,0 Z",
    id: "Path",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    transform: "translate(17.539209, 68.292195) rotate(5.000000) translate(-17.539209, -68.292195) ",
    cx: 17.5392092,
    cy: 68.2921951,
    rx: 2.90634521,
    ry: 4.62062342
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7490473,5.32467192 L14.5113267,5.68066812 C12.0844294,10.0268211 10.8583406,19.9380214 10.8330604,35.4142689 L10.8326613,35.9048424 C10.8326613,59.3048004 6.32071862,67.5479557 4.50549736,77.6215557 L4.45132352,77.9273941 C3.36404189,84.1744908 2.5495949,94.1849797 2.00798257,107.958861 L1.95291924,104.544034 C1.80221651,94.1380607 1.7988795,82.5951197 2.40137388,78.4599541 C3.59344626,70.2782735 5.81597359,66.7868625 5.90342065,61.0003307 L5.90738348,60.4247995 C5.90577521,53.641357 4.53047901,28.3962832 7.53223266,14.5369843 C8.31624129,10.9171636 10.0303241,7.7620072 11.7490473,5.32467192 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(41.038592, 34.684790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5810454,12.1657126 C36.5810454,12.1657126 36.5144295,8.82506885 38.1923221,6.43553805 C39.8702053,4.04600724 39.9368212,1.50780159 41.2066868,1.59088459 C42.4765523,1.6739676 41.2191773,7.57365595 41.2191773,7.57365595 C41.2191773,7.57365595 42.8304493,6.98690707 43.9879005,6.24472541 C45.1453517,5.50254374 48.6551768,1.84371134 49.4753851,2.4920768 C50.8659919,3.59680248 48.6260324,9.82842532 47.4061287,11.0742729 C46.1820616,12.3205179 40.1415645,15.8027648 40.1415645,15.8027648 L22.3521871,32.8859944 L19.6923221,23.8170802 L36.5810454,12.1657126 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999240399,10.6575742 C3.74154505,16.720525 8.76277322,27.8583822 10.8327954,31.1813108 C13.42697,35.3427558 17.5176378,37.1761956 22.3071754,34.0886018 C22.9752046,33.6579459 24.2684942,32.6894327 26.1870442,31.1830624 C25.7612358,27.2280329 24.2110337,23.9223273 21.5389366,21.2645029 C20.3292425,22.2184988 19.7243954,22.6954968 19.7243954,22.6954968 C19.7243954,22.6954968 14.5778264,10.1199245 10.437782,2.83504251 C6.85227566,-3.46758785 -3.17498787,1.44041176 0.999240399,10.6575742 Z",
    id: "Path",
    fill: "#F46465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7775703,22.7020138 C20.699082,25.6814033 21.2675468,27.0848441 21.4829647,26.912336 C21.6983827,26.7398279 21.6160882,24.9470588 21.2360813,21.5340286 L19.7775703,22.7020138 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(22.612575, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.57319491,21.8082086 L7.57319491,27.1730083 L3.4402265,24.00094 C3.4402265,24.00094 2.16988879,18.8609109 1.13671423,15.0432596 C0.488825598,12.6492664 -1.08972528,4.54718819 5.26511552,4.92681678 C10.4708725,-3.82053326 25.6315815,1.59333959 25.7523148,12.2800663 C25.8975258,25.1334433 25.7790222,30.1378215 25.7790222,30.1378215 C17.2059504,30.6068067 12.3805249,29.4253051 7.57319491,21.8082086 Z",
    id: "Path",
    fill: "#33373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35091929,32.0226924 C3.35091929,32.0226924 7.19561923,31.1623273 7.32899808,25.1572882 C7.46237694,19.1522491 7.36874675,17.102436 7.36874675,17.102436 L15.837484,16.9567725 C15.837484,16.9567725 15.9296611,23.6492923 15.9311142,26.0700003 C15.9346474,31.9558383 20.4754779,32.4383878 20.4754779,32.4383878 C20.4754779,32.4383878 19.6992878,37.2945062 12.0255869,37.705816 C6.03413796,38.0274544 3.35091929,32.0226924 3.35091929,32.0226924 Z",
    id: "Path",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39458799,14.1037811 C1.61669809,13.9644325 2.23291584,19.2362589 6.15743415,19.229102 C6.15743415,19.229102 8.43685424,26.7180439 16.3507084,26.7180439 C22.7777786,26.7180439 23.1958704,17.9895432 23.2541685,16.2483176 C23.316883,14.3917401 23.3248328,8.29239863 23.3248328,8.29239863 L5.24751793,8.28439977 L5.39458799,14.1037811 Z",
    id: "Path",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10222086,14.0691493 C6.66785429,14.3152336 6.47788203,15.3032991 6.90368192,15.2169211 C9.06543519,14.7788165 17.8158986,15.356748 18.9426306,10.7700111 C20.3445641,13.6355893 20.6872655,14.3400568 23.7743606,15.1092162 L23.7743606,6.71210049 L4.24887062,4.92681678 C4.24887062,4.92681678 4.55195639,13.9821499 5.10222086,14.0691493 Z",
    id: "Path",
    fill: "#33373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9610027,21.0574409 C14.9610027,21.0574409 16.2835816,23.086876 18.8000562,22.4065847",
    id: "Path",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(16.880529, 21.801749) rotate(-18.000000) translate(-16.880529, -21.801749) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0663364,23.4777114 C16.6614983,23.7150298 17.2263968,23.7141081 17.7211835,23.4394702",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(16.893760, 23.545163) rotate(2.000000) translate(-16.893760, -23.545163) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57793891,17.0340266 C5.80601284,16.218794 5.69340074,15.5035411 4.84214444,15.1685157",
    id: "Path-8",
    stroke: "#F77B7B",
    strokeLinecap: "round",
    transform: "translate(5.261431, 16.101271) rotate(-13.000000) translate(-5.261431, -16.101271) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(12.921471, 30.792605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9008168,0.615852097 C18.7257786,3.43276801 24.3037383,4.46548971 29.4962525,1.4065099 C37.9700081,17.3334296 40.0817642,36.3363936 38.0435186,57.3397029 C25.6870722,62.0027511 15.3020437,61.0856892 6.46073559,55.7558593 L13.9008168,0.615852097 Z",
    id: "Path",
    fill: "#FFE4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1119128,0.628619399 C22.1027739,25.5809019 26.8949964,60.9564928 1.93822068,54.8021125 C15.1954894,31.5350288 -2.82693114,21.0630971 1.25801643,9.03812738 C2.65465099,4.92681678 14.0076275,0.306069191 14.1119128,0.628619399 Z",
    id: "Path",
    fill: "#F98182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09890177,10.9901755 C14.1306206,12.2893451 6.68548961,27.3206803 9.66668742,29.5851294 C12.6478852,31.8495785 17.8368829,32.0938819 18.3964035,33.4773308 C19.5209305,36.2577924 14.084965,43.2767168 2.08850701,54.5341042 L1.93822068,54.8021125 C13.4864944,34.5343894 1.29981104,23.9755985 0.666005701,13.6418576 C2.0040795,11.6412474 3.48179401,10.7575623 5.09890177,10.9901755 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2199562,0.615852097 C14.2199562,0.615852097 10.3136986,7.8044826 12.0944925,10.5098948 C13.8689036,13.215307 13.49232,14.4677657 13.2816884,18.1610595 C13.1093536,21.2363721 19.6546638,28.4381663 19.6546638,28.4381663 C19.4631806,21.0293721 18.2091898,11.6259408 14.2199562,0.615852097 Z",
    id: "Path",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0733101,1.23170419 C32.1227038,8.52236266 33.5885068,14.2426767 34.9561534,24.9440954 C35.7164688,30.885857 35.9063685,39.9874103 35.5258525,52.2487551 L39.2941978,52.9551226 C41.0901637,34.011905 41.6879843,23.3207354 41.0876596,20.8816137 C39.5760502,14.7422453 38.5519956,11.155208 36.5561478,5.54266888 C35.4567955,2.46220718 29.0733101,1.23170419 29.0733101,1.23170419 Z",
    id: "Path",
    fill: "#F98182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0733101,1.23170419 C29.0733101,1.23170419 34.5630171,5.85868275 35.0692536,7.18121235 C35.759576,8.98375269 34.4381016,11.0156732 37.6464573,14.9482612 C39.5070406,17.2233121 35.2664885,26.3610166 35.246765,25.8447551 C35.246765,25.7028769 30.493402,3.08799574 29.0733101,1.23170419 Z",
    id: "Path",
    fill: "#EA5455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 36.889541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7115089,22.8588329 C28.7115089,22.8588329 33.6317274,18.1627778 35.3356944,17.6178065 C37.0396613,17.0728351 46.3733646,16.418154 46.3102547,17.6496064 C46.2387301,18.9689061 40.2325235,18.8929838 39.6771565,19.5420999 C39.1217895,20.1908185 38.3494962,25.2427612 36.2500406,25.7408277 C34.1547923,26.2388941 29.8114756,27.7133444 29.8114756,27.7133444 L10.4781893,37.235363 L12.5379519,27.7140793 L28.7115089,22.8588329 Z",
    id: "Path",
    fill: "url(#linearGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9029779,2.97546824 C8.038548,10.8649799 3.03164196,22.8826299 1.10974979,27.5679665 C-0.812142388,32.2533031 1.12657041,39.3202805 9.5775785,37.9328908 C10.2483916,37.822854 11.1293805,37.5654461 12.2205452,37.1606673 C15.3279344,33.1003049 15.8729488,29.6143615 14.7132575,26.5105696 C13.9846077,26.803758 13.6202828,26.9503522 13.6202828,26.9503522 C13.6202828,26.9503522 22.0197439,12.7585206 24.070775,8.95406057 C27.4967567,2.60038064 19.0685379,-3.97596231 13.9029779,2.97546824 Z",
    id: "Path",
    fill: "#F46465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6202828,26.9503522 C10.7760112,28.2746345 9.53273182,28.6455154 9.89044467,28.0629949 C10.2481575,27.4804744 12.0331435,26.190062 15.2454025,24.1917578 L13.6202828,26.9503522 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(37.000000, 73.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "179.553738 2.5725 191.01623 2.5725 191.01623 146.657 179.553738 146.657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "115.333419 2.5725 183.070927 2.5725 183.070927 146.657 115.333419 146.657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "121.988243 2.5725 133.450735 2.5725 133.450735 146.657 121.988243 146.657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "122.924473 2.5725 125.505431 2.5725 125.505431 146.657 122.924473 146.657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "111.740319 2.5725 123.202812 2.5725 123.202812 146.657 111.740319 146.657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEBEB",
    points: "8.29955272 2.5725 115.257508 2.5725 115.257508 146.657 8.29955272 146.657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D2D2D2",
    points: "8.22364217 1.8375 125.303003 1.8375 125.303003 9.555 8.22364217 9.555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85875,0 L115.118375,0 C117.249503,4.47172551e-15 118.977125,1.72762122 118.977125,3.85875 C118.977125,5.98987878 117.249503,7.7175 115.118375,7.7175 L3.85875,7.7175 C1.72762122,7.7175 2.60988004e-16,5.98987878 0,3.85875 C-2.60988004e-16,1.72762122 1.72762122,3.91482006e-16 3.85875,0 Z",
    id: "Rectangle",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29645,0 L193.559269,0 C195.690398,-1.58910568e-14 197.418019,1.72762122 197.418019,3.85875 C197.418019,5.98987878 195.690398,7.7175 193.559269,7.7175 L113.29645,7.7175 C111.165321,7.7175 109.4377,5.98987878 109.4377,3.85875 C109.4377,1.72762122 111.165321,3.91482006e-16 113.29645,0 Z",
    id: "Rectangle",
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desktop1",
    transform: "translate(194.500000, 53.000000) scale(-1, 1) translate(-194.500000, -53.000000) translate(163.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49372146,-5.53605471e-14 L54.1261216,-5.53605471e-14 C56.5281873,-5.66899778e-14 58.5604182,1.77561028 58.8827177,4.15595539 L62.2114461,28.7403032 C62.5671421,31.3672987 60.7258901,33.7852479 58.0988946,34.1409439 C57.8854302,34.1698471 57.6702622,34.1843478 57.45485,34.1843478 L8.82244987,34.1843478 C6.42038414,34.1843478 4.38815324,32.4087375 4.06585376,30.0283924 L0.737125349,5.44404461 C0.381429335,2.81704911 2.22268136,0.399099905 4.84967685,0.0434038909 C5.06314125,0.0145007444 5.2783092,-5.70973333e-14 5.49372146,-5.53605471e-14 Z",
    id: "Rectangle",
    fill: "#857AF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49372146,-5.53605471e-14 L52.274693,-5.53605471e-14 C54.6767587,-6.00687253e-14 56.7089896,1.77561028 57.0312891,4.15595539 L60.3600175,28.7403032 C60.7157135,31.3672987 58.8744615,33.7852479 56.247466,34.1409439 C56.0340016,34.1698471 55.8188337,34.1843478 55.6034214,34.1843478 L8.82244987,34.1843478 C6.42038414,34.1843478 4.38815324,32.4087375 4.06585376,30.0283924 L0.737125349,5.44404461 C0.381429335,2.81704911 2.22268136,0.399099905 4.84967685,0.0434038909 C5.06314125,0.0145007444 5.2783092,-5.70973333e-14 5.49372146,-5.53605471e-14 Z",
    id: "Rectangle",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7142857,21.9130435 L34.0261247,21.9130435 C35.4897131,21.9130435 36.7667697,22.9060192 37.1274397,24.324472 L39.6345108,34.1843478 L39.6345108,34.1843478 L25.7142857,34.0869565 L25.7142857,21.9130435 Z",
    id: "Rectangle",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(29.486196, 13.689033) rotate(-37.000000) translate(-29.486196, -13.689033) ",
    cx: 29.4861956,
    cy: 13.6890333,
    rx: 2.95202539,
    ry: 3.35466679
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8902602,21.9130435 C35.912776,21.9130435 36.7416888,22.6979078 36.7416888,23.666087 C36.7416888,23.7358957 36.7372849,23.8056422 36.7285008,23.8749537 L34.756983,37.8053109 C34.568359,39.1380907 35.556517,40.3633065 36.9640957,40.5419069 C37.077308,40.5562719 37.1914053,40.5634783 37.3056296,40.5634783 L44.1514286,40.5634783 C44.534872,40.5634783 44.8457143,40.8578024 44.8457143,41.2208696 C44.8457143,41.5839368 44.534872,41.8782609 44.1514286,41.8782609 L25.1008803,41.8782609 C23.6807195,41.8782609 22.5294517,40.7881716 22.5294517,39.4434783 C22.5294517,39.3363755 22.5369153,39.2293894 22.5517938,39.1232171 L24.7471564,23.4572202 C24.8588187,22.5761487 25.6482018,21.9130435 26.5853969,21.9130435 L34.8902602,21.9130435 Z",
    id: "Path",
    fill: "#857AF9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wom4.7",
    transform: "translate(46.000000, 114.500000) scale(-1, 1) translate(-46.000000, -114.500000) translate(0.000000, 8.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(50.825175, 32.532274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(21.761128, 42.485847) scale(-1, 1) rotate(-15.000000) translate(-21.761128, -42.485847) translate(16.261128, 24.485847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77828314,23.7549228 C6.71163324,25.3194583 7.29663171,26.5065165 7.53327855,27.3160973 C7.8882488,28.5304685 8.38798115,32.0515628 8.22186497,32.72929 C8.11112085,33.1811081 7.77646002,33.3874998 7.21788247,33.348465 C7.09849201,34.822641 6.65202761,35.5597291 5.87848926,35.5597291 C4.74980123,35.5597291 4.40985529,34.5586999 3.78756947,34.2204544 C2.09915326,33.3027103 0.021921846,33.9232091 0.021921846,31.5146583 C0.021921846,29.9089577 0.229066778,26.7698694 0.643356643,22.0973934 L1.48440569,0.552861218 L10.0076744,1.36916364 L5.77828314,23.7549228 Z",
    id: "Path-17",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21788247,33.348465 C6.08924653,30.617807 5.37573643,29.1142501 5.07735217,28.8377942 C4.77896791,28.5613383 3.75278174,28.2139423 1.99879366,27.7956061 C1.95435038,29.1905982 2.17614958,29.9504773 2.66419126,30.0752433 C3.05581984,30.1753616 4.95651622,31.2892854 5.93241341,31.9531357 C6.2631633,32.1781271 6.69165299,32.6432368 7.21788247,33.348465 Z",
    id: "Path-18",
    fill: "#A46F6F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.1012638,2.065489 C2.98310054,-4.1022781 -3.94973327,4.86501727 2.6616107,11.6527366 C10.0520947,19.2415584 13.9812949,22.3898807 19.9572237,28.978407 C19.9572237,28.978407 19.9763637,29.7786274 20.0146436,31.3790683 C22.6834889,35.2415387 26.1046481,35.4708515 29.8964199,33.9103612 C30.2699361,31.8011523 30.515195,30.3980643 30.6321967,29.7010972 C31.3054073,25.6908512 31.3260769,24.3308272 26.530205,19.1373739 C21.7343331,13.9435597 13.1913485,4.74160419 10.1012638,2.065489 Z",
    id: "Path",
    fill: "#52C686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9936606,29.0302048 C21.7058876,30.4885507 22.5620011,31.3622249 22.5620011,31.6512272 C22.5620011,31.9402296 21.7058876,31.7642688 19.9936606,31.123345 L19.9936606,29.0302048 Z",
    id: "Path-24",
    fillOpacity: 0.159855769,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-72",
    transform: "translate(70.500000, 114.048124) scale(-1, 1) translate(-70.500000, -114.048124) translate(49.000000, 86.548124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16900804,11.17146 L35.5783217,11.17146 C36.075378,11.17146 36.4783217,11.5744037 36.4783217,12.07146 L36.4783217,53.3613772 C36.4783217,53.8584335 36.075378,54.2613772 35.5783217,54.2613772 L0.94967416,54.2613772 C0.452617885,54.2613772 0.0496741596,53.8584335 0.0496741596,53.3613772 C0.0496741596,53.3452667 0.0501067384,53.3291592 0.0509714284,53.3130719 L2.27030531,12.0231547 C2.29597614,11.5455581 2.69072198,11.17146 3.16900804,11.17146 Z",
    id: "Rectangle",
    fill: "#8D83FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5887415,0.537089424 C25.023091,0.537089424 28.6178416,3.96678454 28.6178416,8.19752786 L28.6171724,8.29642589 L28.4946695,12.8465932 C28.4843491,13.2278427 28.1520452,13.5289244 27.7524478,13.5190779 C27.3794903,13.5098878 27.0797288,13.2330929 27.049809,12.8862577 L27.0475996,12.8109359 L27.1680952,8.35965009 C27.1695578,8.30562061 27.1702891,8.25157536 27.1702891,8.19752786 C27.1702891,4.72953787 24.2236299,1.91817651 20.5887415,1.91817651 C16.9096246,1.91817651 13.9156914,4.71709723 13.8185184,8.20490809 L13.8160839,8.37986294 L13.8160839,12.8287645 C13.8160839,13.2101412 13.4920383,13.5193127 13.0923077,13.5193127 C12.7192258,13.5193127 12.4120739,13.2499894 12.3727785,12.9040068 L12.3685315,12.8287645 L12.3685315,8.37986294 C12.3685315,4.04841873 16.0488449,0.537089424 20.5887415,0.537089424 Z",
    id: "Path",
    fill: "#6055D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03080618,11.17146 L39.0995234,11.17146 C39.5778095,11.17146 39.9725553,11.5455581 39.9982262,12.0231547 L42.21756,53.3130719 C42.2442383,53.8094117 41.8635024,54.2334017 41.3671626,54.2600799 C41.3510753,54.2609446 41.3349678,54.2613772 41.3188573,54.2613772 L10.1404731,54.2613772 C9.65283432,54.2613772 9.25389853,53.8730188 9.24079796,53.385556 L8.13113102,12.0956388 C8.11777745,11.5987619 8.50975053,11.1851384 9.0066274,11.1717849 C9.01468517,11.1715683 9.02274549,11.17146 9.03080618,11.17146 Z",
    id: "Rectangle",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5831471,0.537089424 C26.853047,0.537089424 30.3144848,3.83959293 30.3144848,7.91343746 L30.3123361,8.08733151 L30.1674369,13.9499134 C30.1580134,14.3311841 29.8264186,14.6329766 29.4267991,14.6239858 C29.0538209,14.6155944 28.753409,14.3394421 28.7226734,13.9926719 L28.7202867,13.9173549 L28.865186,8.05477301 C28.8663502,8.00766934 28.8669324,7.96055422 28.8669324,7.91343746 C28.8669324,4.60234627 26.0535859,1.91817651 22.5831471,1.91817651 C19.0807557,1.91817651 16.2302668,4.58114641 16.1346462,7.90067948 L16.1321678,8.0729547 L16.1321678,13.9336342 C16.1321678,14.3150109 15.8081222,14.6241816 15.4083916,14.6241816 C15.0353097,14.6241816 14.7281578,14.354859 14.6888624,14.0088765 L14.6846154,13.9336342 L14.6846154,8.0729547 C14.6846154,3.91101123 18.2209085,0.537089424 22.5831471,0.537089424 Z",
    id: "Path",
    fill: "#6055D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36544604,11.3884856 L5.26816105,50.9755457 L1.53389893,53.696247 C1.13216117,53.9889443 0.569210324,53.9005495 0.276513022,53.4988118 C0.154274515,53.331035 0.093791482,53.1261605 0.105310245,52.9188959 L2.36612672,12.2385451 C2.39263149,11.7616275 2.78708652,11.3884856 3.26474007,11.3884856 L5.36544604,11.3884856 L5.36544604,11.3884856 Z",
    id: "Path-98",
    fill: "#7367F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(35.168140, 72.744253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.90217173 L18.3405649,0 L18.6102255,0.238913193 C19.9173918,1.42721828 25.5980617,6.94587125 27.2303212,14.4889343 C30.311899,28.7296446 26.1876311,55.0312973 26.2788571,60.7987026 C26.3659364,66.5661079 29.222474,70.0459785 30.4095334,78.2006157 C31.5965928,86.355253 31.7086866,122.79949 31.7086866,122.79949 C28.561391,124.579007 25.7920673,124.706398 22.039363,122.692672 L0,1.90217173 Z",
    id: "Path",
    fill: "#3C414A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3829059,91.6900026 L1.82852956e-14,1.90217173 L10.1974004,0.844471694 C10.6517509,32.0365588 16.9933776,74.1997619 16.3829059,91.6900026 Z",
    id: "Path",
    fill: "#4B5059"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLEg",
    transform: "translate(16.304808, 75.214936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76561558,0.665835034 L30.3604418,0 L30.5143246,0.271819549 C31.5136472,2.08017602 36.9893531,12.6681648 35.2985469,24.7029194 C32.925259,41.5954159 25.6054676,61.3987509 25.3100922,64.4239843 C24.7834696,69.8176495 25.8367148,73.7231122 26.2685931,79.2940842 C26.7004714,84.8650563 23.9783942,119.902528 23.9783942,119.902528 C20.9223245,121.656329 17.2857259,122.000522 12.6622283,119.955542 C10.3085884,88.2278821 9.12148938,69.8534843 9.10093125,64.8323488 C9.07009405,57.3006455 9.76561558,0.665835034 9.76561558,0.665835034 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.003397,18.9371095 L13.8652247,20.1887061 C12.4437804,33.3864837 11.2430084,61.4137292 11.7497806,65.7361933 L11.8207213,66.2840603 C12.3882629,71.0526819 12.2369934,83.0232035 11.3669126,102.195625 L10.5951697,91.1913489 C9.66076696,77.5634143 9.16455601,68.9505527 9.10644135,65.3524875 L9.10093125,64.8323488 C9.07009405,57.3006455 9.76561558,0.665835034 9.76561558,0.665835034 L14.108999,0.525564065 C14.5732381,7.76707164 14.5380374,13.9042534 14.003397,18.9371095 Z",
    id: "Path",
    fill: "#4B5059"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(23.256626, 29.183735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.41042,2.55387023 C34.1156717,6.34547965 38.6243273,19.2140638 38.8800431,22.1090821 C39.1681523,25.4484953 35.4158726,30.7681127 35.3541349,35.6023924 C35.2992569,40.4373306 38.1529103,56.2224607 37.2954423,57.5823282 C36.7569663,58.44319 23.5326032,62.7620507 12.7218806,61.6437782 C3.38747854,60.678218 -0.333065348,54.9089193 0.129351509,53.8715033 C1.39154433,51.0398179 7.24976536,42.7751174 6.65296767,38.9167814 C6.06302972,35.0591039 2.63709916,20.8183604 0.935882744,15.9715687 C-0.758473924,11.1247769 -0.193492969,6.03617379 2.96884883,3.95060456 C4.53359182,2.91865418 8.70900567,-0.0131243481 16.1446732,4.42175139e-05 C23.5803408,0.013756166 31.2006302,2.25983447 31.41042,2.55387023 Z",
    id: "Path",
    fill: "#5FDA96",
    transform: "translate(19.447910, 30.913736) scale(-1, 1) translate(-19.447910, -30.913736) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26464295,11.5161555 L3.95140665,11.2214938 C10.1414802,8.60743588 13.8336287,8.23387397 15.027852,10.100808 C18.0244184,14.7853524 15.4408881,27.8637603 8.75221077,40.456217 C7.36479701,43.0682353 5.10063194,46.1212904 1.95971557,49.6153823 L2.17672305,47.9715881 C2.79406716,43.3829934 3.57056364,38.1466018 3.54168612,35.6023924 C3.47994843,30.7681127 -0.272331317,25.4484953 0.015777914,22.1090821 C0.155734469,20.524601 1.56966546,15.9525235 3.26464295,11.5161555 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(32.726711, 8.205586)",
    fill: "url(#linearGradient-10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.84021545,5.121303 C-0.693880919,5.38581114 -0.514224833,9.63634524 2.57056472,9.85827226 C3.20106303,13.955803 5.44960078,15.9080391 8.19096354,16.1339356 L8.03891776,22.3316538 L20.164758,22.3247975 C20.164758,22.3247975 16.7501577,17.9465201 16.9203582,11.952686 C17.0905587,5.95849113 16.8061348,0.327679185 16.8061348,0.327679185 L1.1004106,0.596517617 L1.84021545,5.121303 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(0.000000, 31.660654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7858669,32.0696723 C26.7858669,32.0696723 15.1743576,54.5370799 14.9422138,55.2151035 C14.4901409,56.5354754 12.4298009,62.2564042 11.6616159,63.139743 C10.4944758,64.4818419 2.883461,65.4123884 3.14220522,64.1857951 C3.3074999,63.4022053 4.46694142,61.2730907 6.62052978,57.7984513 C4.00935522,59.1420493 2.62146127,59.4105682 2.45684792,58.6040079 C2.3470381,58.0659699 4.22666338,57.7356735 5.45953566,56.37943 C6.85817126,54.8408355 8.67789377,53.7211746 8.7348009,53.6192047 C10.8170051,49.8881745 18.7620996,28.7357739 18.7620996,28.7357739 L26.7858669,32.0696723 Z",
    id: "Path",
    fill: "url(#linearGradient-11)",
    transform: "translate(14.619056, 46.746957) rotate(7.000000) translate(-14.619056, -46.746957) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.423394,4.42741743 C24.1237961,12.2547657 22.287792,22.8183376 20.4431427,26.460673 C20.1412358,27.0568005 19.318016,28.6825081 17.9734833,31.3377957 C19.5508416,36.4459228 24.2866293,37.9792973 28.394566,35.9463921 C30.4740333,32.5042616 31.7277243,30.377293 32.1556389,29.5654863 C34.40985,25.2911356 37.425911,10.9127387 38.2844779,7.62388835 C40.2512393,0.0863082406 28.7229919,-3.39993082 26.423394,4.42741743 Z",
    id: "Path",
    fill: "#52C686"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.1140507,30.0837243 C38.3192847,20.6575822 39.6412431,8.65573284 44.0408453,4.62730429 C47.5332409,1.42954553 53.0766741,2.31662582 53.0766741,2.31662582 C53.0766741,2.31662582 57.8778088,-1.5254511 62.5858704,2.31662582 C67.293932,6.15870274 67.3702718,19.5200905 64.0964189,27.9178599 C60.8225659,36.3156294 57.3873786,46.0362363 44.5091347,46.0362363 C37.293151,46.0362363 25.1054324,40.7302579 32.1140507,30.0837243 Z",
    id: "Path",
    fill: "#33373E",
    transform: "translate(48.189284, 23.322636) scale(-1, 1) translate(-48.189284, -23.322636) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-113",
    transform: "translate(56.000000, 110.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9725,1.08137144 C48.0200569,1.08137144 51.30125,4.22832358 51.30125,8.11028577 L51.30125,62.1788576 L25.9325,62.1788576 L25.9325,8.11028577 C25.9325,4.22832358 29.2136931,1.08137144 33.26125,1.08137144 L43.9725,1.08137144 Z M43.9725,4.05514289 L33.26125,4.05514289 C30.9719079,4.05514289 29.1075301,5.80019221 29.0352974,7.97904456 L29.033125,8.11028577 L29.033125,59.2050861 L48.200625,59.2050861 L48.200625,8.11028577 C48.200625,5.9146058 46.3811363,4.12650393 44.1093396,4.05722646 L43.9725,4.05514289 Z",
    id: "Rectangle",
    fill: "#9FE1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.115,0 L45.555,0 C46.5491125,-4.04660118e-16 47.355,0.80588745 47.355,1.8 L47.355,4.1475429 C47.355,5.14165545 46.5491125,5.9475429 45.555,5.9475429 L31.115,5.9475429 C30.1208875,5.9475429 29.315,5.14165545 29.315,4.1475429 L29.315,1.8 C29.315,0.80588745 30.1208875,-3.94290921e-17 31.115,0 Z",
    id: "Rectangle",
    fill: "#6AAAB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2275,25.7694846 C47.5118209,25.7694846 48.5601209,26.7386676 48.6206746,27.9560629 L48.6234375,28.0673989 L48.6234375,33.6778017 L46.0865625,33.6778017 L46.0865625,28.2021671 L25.4516212,28.2021671 L25.4518149,33.2521717 L22.9149399,33.2521717 L22.9149399,28.0673989 C22.9149399,26.8356225 23.9254657,25.8302108 25.194792,25.7721345 L25.3108774,25.7694846 L46.2275,25.7694846 Z",
    id: "Path",
    fill: "#6AAAB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.49625,31.3597717 L56.93875,31.3597717 C58.8068532,31.3597717 60.32125,32.8122111 60.32125,34.603886 L60.32125,103.811658 C60.32125,105.603333 58.8068532,107.055772 56.93875,107.055772 L26.49625,107.055772 C24.6281468,107.055772 23.11375,105.603333 23.11375,103.811658 L23.11375,34.603886 C23.11375,32.8122111 24.6281468,31.3597717 26.49625,31.3597717 Z",
    id: "Rectangle",
    fill: "#9FE1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02,31.3597717 L45.1,31.3597717 C46.9681032,31.3597717 48.4825,32.8122111 48.4825,34.603886 L48.4825,103.811658 C48.4825,105.603333 46.9681032,107.055772 45.1,107.055772 L9.02,107.055772 C7.15189683,107.055772 5.6375,105.603333 5.6375,103.811658 L5.6375,34.603886 C5.6375,32.8122111 7.15189683,31.3597717 9.02,31.3597717 Z",
    id: "Rectangle",
    fill: "#BCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1419183,30.8190859 C52.7402799,30.8190859 54.8556132,32.8025661 54.9316755,35.276953 L54.9337933,35.4149145 L54.9337933,54.0685718 C54.9337933,54.2178781 54.8075935,54.3389147 54.6519183,54.3389147 C54.5135402,54.3389147 54.3984515,54.2432808 54.3745846,54.1171663 L54.3700433,54.0685718 L54.3700433,35.4149145 C54.3700433,33.2192346 52.5505546,31.4311327 50.2787579,31.3618552 L50.1419183,31.3597717 L21.704375,31.3597717 C21.5486997,31.3597717 21.4225,31.238735 21.4225,31.0894288 C21.4225,30.9567121 21.5222134,30.846332 21.6537076,30.8234415 L21.704375,30.8190859 L50.1419183,30.8190859 Z",
    id: "Path-216",
    fill: "#6AAAB2"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.48b19d43c6990b258203ca8e70a5b304.svg";
export { ForwardRef as ReactComponent };